import {
    withRequiredAuthInfo,
    WithLoggedInAuthInfoProps,
} from "@propelauth/react";
import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { DeveloperProjectModel } from "@models/project";
import { getProject } from "../../api/ProjectLoader";
import { ProjectInfoDeveloper } from "../projects/ProjectInfo";
import FilesView from "../files/FilesView";
import DeveloperBidSummary from "../bid/DeveloperBidSummaryView";
import QAWidget from "../qa_forum/qa_widget";
import { DeveloperVEWidget } from "../ve/VEWidget";
import { Spinner } from "../ui/spinner";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";

function ViewProjectAsDeveloper(props: WithLoggedInAuthInfoProps) {
    const [project, setProject] = useState<DeveloperProjectModel | null>(null);
    const { project_id } = useParams<string>();

    const fileContext = {
        editing: true,
        context: "project",
        permission: "edit",
        parent_id: project_id,
        parent_type: "project",
        project_id: project_id,
        folder_id: project?.root.id,
    };

    useEffect(() => {
        setProject(null);
        if (project_id) {
            getProject(project_id, props.accessToken).then((data) => {
                setProject(data);
            });
        } else {
        }
    }, [project_id]);

    if (!project) {
        return <div><BaseLoadingSpinner/></div>;
    }

    return (
        <div className={"container"}>
            
            <br />
            {/*// note - using developerBidderSummary component here which is also used in Developer side.*/}
            {/*//might want to create a separate component for Bidder...*/}
            <ProjectInfoDeveloper project={project} />
            <br />

            {/*//note - using developerBidderSummary component here which is also used in Developer side.*/}
            {/*//might want to create a separate component for Bidder...*/}
            <DeveloperBidSummary project={project} />

            <br />

            <div className="flex gap-4">
                <div className="flex-1 flex flex-col justify-end">
                    <QAWidget renderOnHomePage={true} />
                </div>
                <div className="flex-1 flex flex-col justify-end">
                    <DeveloperVEWidget ve_summary={project.ve_summary} />
                </div>
            </div>
            {/*// Do not render this component if project is not loaded */}
            <br />
            <FilesView uploadContext={fileContext} />
        </div>
    );
}

// By default, if the user is not logged in they are redirected to the login page
export default withRequiredAuthInfo(ViewProjectAsDeveloper);
